import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.17647,1072.47059 L1355.29412,1072.47059 L1355.29412,1511.02118 L988.461176,1724.70588 C970.955294,1734.98353 949.044706,1734.98353 931.538824,1724.70588 L564.705882,1511.02118 L564.705882,1072.47059 L338.823529,1072.47059 L338.823529,685.647059 C338.823529,665.543529 349.665882,646.908235 366.832941,636.856471 L677.647059,455.811765 L677.647059,620.705882 L1242.35294,620.705882 L1242.35294,455.811765 L1553.16706,636.856471 C1570.33412,646.908235 1581.17647,665.543529 1581.17647,685.647059 L1581.17647,1072.47059 Z M1694.11765,1072.47059 L1694.11765,685.647059 C1694.11765,625.562353 1661.92941,569.430588 1609.97647,539.162353 L1242.35294,325.138824 L1242.35294,56 L677.647059,56 L677.647059,325.138824 L310.023529,539.162353 C258.070588,569.430588 225.882353,625.562353 225.882353,685.647059 L225.882353,1072.47059 L-5.68434189e-14,1072.47059 L-5.68434189e-14,1637.17647 L557.025882,1637.17647 L874.729412,1822.28706 C901.157647,1837.64706 930.409412,1845.32706 960,1845.32706 C989.590588,1845.32706 1018.95529,1837.64706 1045.27059,1822.28706 L1362.97412,1637.17647 L1920,1637.17647 L1920,1072.47059 L1694.11765,1072.47059 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconModuleSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconModuleSolid, _Component);

  var _super = _createSuper(IconModuleSolid);

  function IconModuleSolid() {
    _classCallCheck(this, IconModuleSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconModuleSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconModule",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconModuleSolid.displayName = "IconModuleSolid";
  return IconModuleSolid;
}(Component);

IconModuleSolid.glyphName = 'module';
IconModuleSolid.variant = 'Solid';
IconModuleSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconModuleSolid;
export { IconModuleSolid };